import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9c993114"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "seaction-header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seaction-header-tag"
}, null, -1));
const _hoisted_3 = {
  class: "seaction-header-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seaction-header-line"
}, null, -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'my-seaction-header',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1), _hoisted_4]);
    };
  }
});